import React from 'react';
import ReactDOM from 'react-dom';
import '@ifeng-fe/container_channel/common/client/commoncss/resetMobile.css';
import './layout/body.css';
import Layout from './layout/index';

/* eslint-disable */
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
